export const inView = (elm) => {
  let viewOffset = 100;
  let windowView = $(window).height();
  let offset = elm.offset().top;
  return offset - viewOffset <= $(window).scrollTop() + windowView;
};
